<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 md12 lg12>
        <material-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Registrazione Npo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-autocomplete
              v-model="registeringNpo"
              :loading="loading"
              :items="npoList"
              :search-input.sync="searchNpo"
              :rules="registeringNpo.fiscalCode"
              cache-items
              class="mx-4"
              flat
              item-text="fiscalCode"
              item-value="fiscalCode"
              label="Codice fiscale NPO"
              solo
              clearable
            ></v-autocomplete>
            <v-combobox
            v-model="registeringNpo"
              :loading="loading"
              :items="npoList"
              :search-input.sync="searchNpo"
              item-text="fiscalCode"
              item-value="fiscalCode"
              label="Codice fiscale NPO"
            ></v-combobox>
            <v-text-field
              v-model="registeringNpo.name"
              :counter="1"
              :rules="registeringNpo.nameRules"
              label="Nome NPO"
              required
            ></v-text-field>
            <v-text-field
              v-model="registeringNpo.firstName"
              :counter="1"
              :rules="registeringNpo.selectfirstNameRules"
              label="Nome referente"
              required
            ></v-text-field>
            <v-text-field
              v-model="registeringNpo.lastName"
              :counter="1"
              :rules="registeringNpo.lastNameRules"
              label="Cognome referente"
              required
            ></v-text-field>
            <v-text-field
              v-model="registeringNpo.address"
              :counter="1"
              :rules="registeringNpo.addressRules"
              label="Indirizzo"
              required
            ></v-text-field>
            <v-text-field
              v-model="registeringNpo.zipCode"
              :counter="1"
              :rules="registeringNpo.zipCodeRules"
              label="CAP"
              required
            ></v-text-field>
            <v-text-field
              v-model="registeringNpo.city"
              :counter="1"
              :rules="registeringNpo.cityRules"
              label="città"
              required
            ></v-text-field>
            <v-text-field
              v-model="registeringNpo.zipCode"
              :counter="1"
              :rules="registeringNpo.zipCodeRules"
              label="Provincia"
              required
            ></v-text-field>

            <v-text-field v-model="registeringNpo.email" :rules="registeringNpo.emailRules" label="E-mail" required></v-text-field>

            <v-select
              v-model="select"
              :items="items"
              :rules="[v => !!v || 'Item is required']"
              label="Item"
              required
            ></v-select>

            <v-checkbox
              v-model="checkbox"
              :rules="[v => !!v || 'You must agree to continue!']"
              label="Accetto termini e condizioni del servizio Donapp"
              required
            ></v-checkbox>

            <v-btn color="success" class="mr-4" @click="validate">Valida il form</v-btn>

            <v-btn color="error" class="mr-4" @click="reset">Reset del form</v-btn>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import apiService from '@/services'
// const apiService = new ApiService()

export default {
  data: () => ({
    npoList: [],
    loading: false,
    searchNpo: '',
    registeringNpo: {
      firstName: '',
      firstNameRules: [
        v => !!v || 'È necessario inserire un nome',
        v =>
          (v && v.length <= 10) || 'Il nome deve essere al massimo 10 caratteri'
      ],
      lastName: '',
      lastNameRules: [
        v => !!v || 'È necessario inserire un cognome',
        v =>
          (v && v.length <= 10) ||
          'Il cognome deve essere al massimo 10 caratteri'
      ],
      address: '',
      addressRules: [
        v => !!v || 'È necessario inserire un cognome',
        v =>
          (v && v.length <= 10) ||
          'Il cognome deve essere al massimo 10 caratteri'
      ],
      npoName: '',
      npoNameRules: [
        v => !!v || 'È necessario inserire un nome',
        v =>
          (v && v.length <= 10) || 'Il nome deve essere al massimo 10 caratteri'
      ],
      name: '',
      nameRules: [
        v => !!v || 'È necessario inserire un nome',
        v =>
          (v && v.length <= 10) || 'Il nome deve essere al massimo 10 caratteri'
      ],
      zipCode: '',
      zipCodeRules: [
        v => !!v || 'È necessario inserire un nome',
        v =>
          (v && v.length <= 10) || 'Il nome deve essere al massimo 10 caratteri'
      ],
      email: '',
      emailRules: [
        v => !!v || 'Inserisci un email valida',
        v => /.+@.+\..+/.test(v) || "L'email inserita non è valida"
      ],
      fiscalCode: null,
      fiscalCodeRules: [v => !!v || 'Inserisci il codice fiscale']
    },
    valid: true,
    select: null,
    items: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
    checkbox: false
  }),

  methods: {
    validate () {
      console.log(this.$refs.form)
      console.log(this.registeringNpo)
      if (this.$refs.form.validate()) {

        // this.snackbar = true
      }
    },
    getNpos () {
      apiService.fetchData('npos').then(response => {
        setTimeout(() => {
          this.npoList = response
          console.log(this.npoList)
        }, 800)
      })
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  },
  beforeMount () {
    this.getNpos()
  }
}
</script>
